module.exports = __webpack_public_path__ + "static/media/4.d3012cad.png";